<template>
  <div>
    <b-loading :active.sync="loading_inicial" />
    <div class="w-full flex justify-between items-center gap-2">
      <Lynx-Title :text=" empresa ? 'Parcelamentos da empresa '+empresa.id : 'Parcelamentos'" />

      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="goTipoParcelamento()"
        >Tipo Parcelamento</v-btn
      >
      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="show_modal_parcelamento()"
        >Cadastrar</v-btn
      >
      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="listar_parcelamento()"
      >
        Atualizar</v-btn
      >

    </div>

    <b-table
      :columns="columns"
      :data="loading ? [] : lista_parcelamento"
      :loading="loading"
      backend-pagination
      paginated
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      detailed
      detail-key="id"
      :detail-transition="transitionName"
      :opened-detailed="defaultOpenedDetails"
      @details-open="(row, index) => fecharTodos(row, index)"
      style="font-size:13px;"
    >
      <template slot-scope="props" v-if="props.row.id != null">
        <b-table-column field="id">
          {{ props.row.id }}
        </b-table-column>
        <b-table-column field="tipo_parcelamento.nome">
          {{ props.row.tipo_parcelamento.nome }}
        </b-table-column>

        <b-table-column field="observacao">
          {{ props.row.observacao }}
        </b-table-column>
        <b-table-column field="parcelas_count">
          {{ props.row.parcelas_count }}
        </b-table-column>
        <b-table-column field="status">
          <div
            class="text-center"
            :class="{
              'bg-success-base rounded-full p-2 text-neutral-200':
                props.row.status == 1,
              'bg-info-base rounded-full p-2 text-neutral-200':
                props.row.status == 2,
              'bg-error-base rounded-full p-2 text-neutral-200':
                props.row.status == 3 || props.row.status == 4 || props.row.status == 5,
            }"
          >
            <span v-if="props.row.status == 1">Pago</span>
            <span v-if="props.row.status == 2">Normal</span>
            <span v-if="props.row.status == 3">Devedora</span>
            <span v-if="props.row.status == 4">Desistencia</span>
            <span v-if="props.row.status == 5">Não formalizado</span>

          </div>
        </b-table-column>

        <b-table-column field="created_at">
          {{ formatEnToBr(props.row.created_at) }}
        </b-table-column>

        <b-table-column field="acoes">
          <div class="flex text-sm">
            <div class="flex text-sm items-center">
              <Lynx-Button
                class=""
                icon-size="4"
                icon="Edit"
                size="small"
                @click.native="atualizar(props.row)"
              />
              <Lynx-Button
                class=""
                icon-size="4"
                icon="Trash"
                size="small"
                color="error-base"
                @click.native="confirmDelete(props.row)"
              />
             <Logs  :logs="props.row.logs" />

            </div>
          </div>
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum parcelamento encontrado!" />
      </template>
      <template slot="detail" slot-scope="props">
        <Parcelas :parcelamentoEmpresaId="props.row.id" />
      </template>
    </b-table>

    <b-modal :active.sync="modalParcelamento" :width="600">
      <CriarParcelamento
        @listarEmpresaParcelamento="listar_empresa_parcelamento"
        :listaCampos="lista_campos"
        :empresa="empresa"
      />

      <footer class="modal-card-foot flex justify-between">
        <b-button
          @click.native="hide_modal_parcelamento()"
          type="is-danger"
          class="mt-4"
          >Cancelar</b-button
        >
      </footer>
    </b-modal>
  </div>
</template>

<script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import CriarParcelamento from "@/views/parcelas/CriarParcelamento";
import moment from "moment";
import Parcelas from "@/views/parcelas/Parcelas";
import Logs from "@/views/logs/Logs";
export default {
  components: { NotFoundData, Treeselect, CriarParcelamento, Parcelas, Logs},
  props: {
    empresa: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      monthNames,
      loading_inicial: false,
      modalParcelamento: false,
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      lista_campos: [],
      preciona: 0,
      editavel: 0,
      regimes_tributario: [],
      integracao: null,
      tipo: null,
      setor: null,
      regra_acesso: null,
      colunas: [],
      motivosOptions: [],

      columns: [
        {
          field: "id",
          label: "ID",
          sortable: true,
        },
        {
          field: "tipo_parcelamento.nome",
          label: "Tipo de Parcelamento",
          sortable: true,
        },
        {
          field: "observacao",
          label: "Observação",
        },
        {
          field: "parcelas_count",
          label: "Total de parcelas",
        },
        {
          field: "status",
          label: "Status",
        },
        {
          field: "created_at",
          label: "Criação",
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],
      filtros: {
        page: 1,
        perPage: 10,
        empresa_id: null,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
      showDetailIcon: true,
      useTransition: true,
      defaultOpenedDetails: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    lista_parcelamento() {
      return this.$store.state.parcelamento.lista_parcelamento.data;
    },
    pagination() {
      return this.$store.state.parcelamento.lista_parcelamento.pagination;
    },
    mensagem_alert() {
      return this.$store.state.parcelamento.mensagem_alert;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.listar_parcelamento();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_parcelamento();
    },
    empresa() {
      this.listar_parcelamento();
    },
  },
  mounted() {
    this.inicial();
  },
  methods: {
    hasRole,
    async inicial() {
      this.loading_inicial = true;
      // await this.listar_parcelamento();
      await this.listar_tipo_parcelamento();
      this.loading_inicial = false;
    },
    confirmDelete(parcelamento) {
      this.$buefy.dialog.confirm({
        message: `Esta ação irá excluir o parcelamento do sistema. Deseja continuar?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-danger",
        onConfirm: () => {
          this.delete(parcelamento);
        },
      });
    },
    delete(parcelamento) {
      this.loading = true;
      this.$store
        .dispatch("parcelamento/delete_parcelamento", parcelamento)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.listar_parcelamento();
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    hide_modal_parcelamento() {
      this.modalParcelamento = false;
    },
    show_modal_parcelamento() {
      this.lista_campos = null;
      this.modalParcelamento = true;
    },

    goTipoParcelamento() {
      this.$router.push({ name: "tipo-parcelamento.index" });
    },
    async listar_parcelamento() {
      this.loading = true;
      this.filtros.empresa_id = this.empresa.id;
      const { filtros } = this;
      await this.$store.dispatch("parcelamento/listar_parcelamento", filtros);
      this.loading = false;
    },

    async listar_tipo_parcelamento() {
      this.loading = true;

      await this.$store.dispatch(
        "tipoParcelamento/listar_tipo_parcelamento",
        {}
      );
      this.loading = false;
    },

    atualizar(value) {
      this.lista_campos = value;
      this.modalParcelamento = true;
    },
    onPageChange(page) {
      this.current_page = page;
    },
    voltar() {
      this.$router.push({
        name: "ativiades-competencia.index",
        params: { setor: this.$route.params.setor },
      });
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
    transitionName() {
      if (this.useTransition) {
        return "fade";
      }
    },
    listar_empresa_parcelamento() {
      this.$emit("listarEmpresaParcelamento");
      this.hide_modal_parcelamento();
    },
    fecharTodos(row, index) {
      this.defaultOpenedDetails = [row.id];
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
</style>
